import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { SELECTORS } from '@oneaudi/stck-store';
import { useServicesContext, VehicleBasic } from '@oneaudi/vtp-shared';
import Tiles from './Tiles';
import Tile from './Tile';
import { ContentService } from '@oneaudi/content-service';
import ResultsBar from './ResultsBar';
import { LayoutContainer } from './Tiles.styles';
import LoadMoreButton from './LoadMoreButton';
import { TileContext, TileContextState } from '../../hooks/tileHook';
import ZeroResultsPage from './ZeroResultsPage';

interface Props {}

const Results: React.FC<Props> = () => {
  const resultVehicles: VehicleBasic[] = Array.from(
    useSelector((state) => SELECTORS.VEHICLES.getResultVehiclesMap(state)).values()
  );
  const [focusIndex, setFocusIndex] = useState<number | null>(null);
  const prevVehicleCountRef = useRef(resultVehicles.length);

  useEffect(() => {
    if (focusIndex === null && resultVehicles.length > prevVehicleCountRef.current - 1) {
      setFocusIndex(prevVehicleCountRef.current);
    }
    prevVehicleCountRef.current = resultVehicles.length;
  }, [resultVehicles]);

  const servicesContext = useServicesContext();
  const audiContentService = servicesContext.getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const content = audiContentService.getContent();
  const tileContextValue: TileContextState = useMemo(() => {
    return {
      appContext: 'results',
      contentConfiguration: content.fields,
    };
  }, []);

  const appContext = content?.fields?.appContext || 'results';

  return (
    <TileContext.Provider value={tileContextValue}>
      <LayoutContainer direction="column" appContext={appContext}>
        <ResultsBar />
        {resultVehicles.length === 0 ? (
          <ZeroResultsPage context="results" />
        ) : (
          <>
            <Tiles>
              {resultVehicles.map((resultVehicle, index) => (
                <Tile
                  key={resultVehicle.id}
                  vehicle={resultVehicle}
                  focusOnMount={index === focusIndex}
                />
              ))}
            </Tiles>
            <LoadMoreButton onLoadMore={() => setFocusIndex(null)} />
          </>
        )}
      </LayoutContainer>
    </TileContext.Provider>
  );
};

export default Results;
